import { cloneDeep, get, isArray, set } from 'lodash';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import { ANTRAG_VERBUNDPARTNER } from 'src/lib/constants/componentsPath';
import { KOSTEN_ARTEN, KOSTEN_POSITION, KOSTENTRAEGER } from 'src/lib/constants/constant';
import { FormulasResultType } from 'src/lib/types/types';
import {
	addIndexesToPath,
	getFieldNamefromDataPath,
	groupKostenByPosition,
	isAntragBerechtigtHochschule,
	isAntragstellerHAW,
	isTrue,
} from 'src/utils/helper';
import { getBasisDataKostenKategorie } from '../../application-helper-function/AppHelperfunctions';
import { calculateGesamtSumme, calculateProjektDauer, calculateProjektStartJahr, ersteVerbundPartnerAnlegen } from '../commonFormulas';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import KostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = AntragSchema.attributes;
const KP_P = KostenPositionSchema.attributes;

export const executeLoeweAntragFormulas = (
	application: any,
	kostenKategories: any,
	vonTag: number,
	vonMonat: string,
	bisTag: number,
	bisMonat: string,
) => {
	let appCopy = cloneDeep(application);
	let result: FormulasResultType[] = [];
	const kostenKategoriesGroup = groupKostenByPosition(kostenKategories);

	let calcultedProjkJahr = calculateProjektStartJahr(application, vonTag, vonMonat);
	if (isArray(calcultedProjkJahr)) {
		for (let ele of calcultedProjkJahr) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calcultedProjkJahr);
	let calcultedProjkdauer = calculateProjektDauer(application, vonTag, vonMonat, bisTag, bisMonat);
	if (isArray(calcultedProjkdauer)) {
		for (let ele of calcultedProjkdauer) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calcultedProjkdauer);

	let erstePartnerAnlegen = ersteVerbundPartnerAnlegen(appCopy);
	if (isArray(erstePartnerAnlegen)) {
		for (let ele of erstePartnerAnlegen) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...erstePartnerAnlegen);

	if (get(appCopy, P.Allgemein_Projektdauerin_Jahren.path) > 0) {
		if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Personalkosten)) {
			let calculatedPersonalKosten: any = [];

			calculatedPersonalKosten = calculatePersonalKosten(appCopy);

			for (let ele of calculatedPersonalKosten) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
			result.push(...calculatedPersonalKosten);

			// Administrationspauschale nach Personalkosten berechnen
			let calculatedAdminPauschale = calculateAdministrationspauschale(appCopy, kostenKategories);
			if (isArray(calculatedAdminPauschale)) {
				for (let ele of calculatedAdminPauschale) {
					set(appCopy, get(ele, 'path'), get(ele, 'value'));
				}
			}
			result.push(...calculatedAdminPauschale);
		}

		// Sachkosten
		if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Sachkosten)) {
			let calculatedSachKosten: any[] = [];

			calculatedSachKosten = calsulateSachkosten(appCopy);

			result.push(...calculatedSachKosten);
			for (let ele of calculatedSachKosten) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}

		// Einnahmen
		if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
			let calculatedEigenmittel: any = [];
			calculatedEigenmittel = calculateEinnahmen(appCopy);
			result.push(...calculatedEigenmittel);
			for (let ele of calculatedEigenmittel) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}

		// Berechnet die Förderquote auf Jarhen aufgeteilt für Antragsteller und jede Partner
		let calculatedFoerderQuote = calculateFoerderquote(appCopy);
		result.push(...calculatedFoerderQuote);
		for (let ele of calculatedFoerderQuote) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}

		// Berechnet die Jahrenaufteilung für Ausgaben, Einnahmen, Zuwendung und Förderquote
		let calculatedJahresaufteilung = calculateJahresAufteilung(appCopy);
		result.push(...calculatedJahresaufteilung);
		for (let ele of calculatedJahresaufteilung) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}

		// Berechnet die Gesamt Förderquote für Antragsteller und jede Partner
		let calculatedGesamtFoerderquote = calculateGesamtFoerderquote(appCopy);
		result.push(...calculatedGesamtFoerderquote);
		for (let ele of calculatedGesamtFoerderquote) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}

		let calculatedGesamtSummeSkizze = calculateGesamtSumme(appCopy);
		if (isArray(calculatedGesamtSummeSkizze)) {
			for (let ele of calculatedGesamtSummeSkizze) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}

		result.push(...calculatedGesamtSummeSkizze);
	}

	return result;
};

function calculatePersonalKosten(application: any) {
	let result = [];

	const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	for (let i = 0; i < allKostenPosition.length; i++) {
		const eachKostenPosition = allKostenPosition[i];
		if (
			get(eachKostenPosition, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten &&
			!isTrue(get(eachKostenPosition, `${KP_P.Personalausgaben_LOEWE_Antrag.schema.attributes.Administrationspauschale.path}`, false))
		) {
			const isHochschule = isUnternehmenHochschule(eachKostenPosition, application);
			const KalkulationPersonalKosten = transformData(
				eachKostenPosition,
				isHochschule,
				get(application, P.Allgemein_Projektstart_Jahr.path),
				get(application, P.Allgemein_Projektdauerin_Jahren.path),
			);
			result.push({
				path: `${P.Foerderantrag_Kostenpositions.path}.${i}`,
				value: KalkulationPersonalKosten,
			});
		}
	}

	return result;
}
function calsulateSachkosten(application: any) {
	let result: any = [];
	const allKostenPositionARR = get(application, P.Foerderantrag_Kostenpositions.path, []);

	for (let i = 0; i < get(application, P.Foerderantrag_Kostenpositions.path, []).length; i++) {
		const eachSachKosten = allKostenPositionARR[i];

		if (get(eachSachKosten, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Sachkosten) {
			const KalkulationSachKoste = transformSachkostenData(
				eachSachKosten,
				get(application, P.Allgemein_Projektstart_Jahr.path),
				get(application, P.Allgemein_Projektdauerin_Jahren.path),
			);

			result.push({
				path: `${P.Foerderantrag_Kostenpositions.path}.${i}`,
				value: KalkulationSachKoste,
			});
		}
	}

	return result;
}
function calculateEinnahmen(application: any) {
	let result: any = [];

	const allKostenPositionARR = get(application, P.Foerderantrag_Kostenpositions.path, []);
	for (let i = 0; i < allKostenPositionARR.length; i++) {
		const eachEigenmittel = allKostenPositionARR[i];
		if (get(eachEigenmittel, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Eigenmittel) {
			const allKostenProJahrEigenmittelARR = get(
				application,
				addIndexesToPath(
					P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr.path,
					[`${i}`],
					['Foerderantrag_Kostenpositions'],
				),
				[],
			);

			let KalkulationAllgemeinProJahr = transformAllgemeinKostenProJahrData(
				allKostenProJahrEigenmittelARR,
				get(application, P.Allgemein_Projektstart_Jahr.path),
				get(application, P.Allgemein_Projektdauerin_Jahren.path),
			);

			result.push({
				path: addIndexesToPath(
					P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr.path,
					[`${i}`],
					['Foerderantrag_Kostenpositions'],
				),
				value: get(KalkulationAllgemeinProJahr, 'KostenProJahr'),
			});
			result.push({
				path: addIndexesToPath(
					P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
					[`${i}`],
					['Foerderantrag_Kostenpositions'],
				),
				value: get(KalkulationAllgemeinProJahr, 'gesamtSumme'),
			});
		}
	}
	return result;
}
//
function calculateFoerderquote(application: any) {
	let result: any = [];
	const allKostenPositionsARR = get(application, P.Foerderantrag_Kostenpositions.path, []);
	const AntragstellerId = get(application, `${P.Antragstellende_Organisation.path}.id`);
	const VerbundparterIds = get(application, P.Verbundpartner.path, []).map((ele: any) => get(ele, 'Verbundpartner.id'));
	const allKostenpositionVonAntragsteller = allKostenPositionsARR.filter((ele: any) => get(ele, `${KP_P.Unternehmen.path}.id`) === AntragstellerId);
	result.push({
		path: P.Antragstellende_Organisation_Foerderquote.path,
		value: calculateFoerderquoteData(allKostenpositionVonAntragsteller),
	});
	VerbundparterIds.forEach((eachVerbundpartnerId: any) => {
		const VPartnerIndex = get(application, P.Verbundpartner.path, []).findIndex(
			(ele: any) => get(ele, 'Verbundpartner.id') === eachVerbundpartnerId,
		);
		const allKostenpositionVonEachVPartner = allKostenPositionsARR.filter(
			(ele: any) => get(ele, `${KP_P.Unternehmen.path}.id`) === eachVerbundpartnerId,
		);
		result.push({
			path: `${P.Verbundpartner.path}.${VPartnerIndex}.Foerderquote`,
			value: calculateFoerderquoteData(allKostenpositionVonEachVPartner),
		});
	});

	return result;
}
function calculateJahresAufteilung(application: any) {
	let result: any = [];
	const allKostenposition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	const calculatedJahreaufteilung = calculateFinancials(allKostenposition);
	result.push(
		{
			path: P.Allgemein_Geplante_Projektausgaben.path,
			value: get(calculatedJahreaufteilung, 'gesamtAusgaben'),
		},
		{
			path: P.Allgemein_Beantragte_Zuwendung.path,
			value: get(calculatedJahreaufteilung, 'gesamtZuwendung'),
		},
		{ path: P.Bewilligung_Jahresaufteilung.path, value: get(calculatedJahreaufteilung, 'Jahrenaufteilung') },
	);
	return result;
}
function calculateGesamtFoerderquote(application: any) {
	let result: any = [];

	const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	// Förderquote für Antragsteller
	const allAusgabenAntragsteller_Arr = allKostenPosition.filter(
		(ele: any) =>
			get(ele, `${KP_P.Unternehmen.path}.id`) === get(getLocalstorageToken(), 'organisationId') &&
			get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe',
	);

	const allEinnahmenAntragsteller_Arr = allKostenPosition.filter(
		(ele: any) =>
			get(ele, `${KP_P.Unternehmen.path}.id`) === get(getLocalstorageToken(), 'organisationId') &&
			get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme',
	);

	const ausgabenGesamtAntragsteller = allAusgabenAntragsteller_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const einnahmenGesamtAntragsteller = allEinnahmenAntragsteller_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const zuwendungGesamtAntragsteller = ausgabenGesamtAntragsteller - einnahmenGesamtAntragsteller;
	const foerderQuoteAntragsteller = ausgabenGesamtAntragsteller !== 0 ? (zuwendungGesamtAntragsteller / ausgabenGesamtAntragsteller) * 100 : 0;

	result.push({
		path: P.Orga_Foerderquote_Gesamt.path,
		value: !isNaN(foerderQuoteAntragsteller) ? foerderQuoteAntragsteller.toFixed(2) : 0,
	});

	// Förderquote für einzel Verbundpartner
	const allVerbundPartner = get(application, P.Verbundpartner.path, []);

	allVerbundPartner.forEach((eachPartner: any, i: number) => {
		const eachPartnerId = get(eachPartner, 'Verbundpartner.id');
		if (eachPartnerId) {
			const allAusgabenEachPartner_Arr = allKostenPosition.filter(
				(ele: any) => get(ele, `${KP_P.Unternehmen.path}.id`) === eachPartnerId && get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe',
			);
			const allEinnahmenEachPartnerr_Arr = allKostenPosition.filter(
				(ele: any) => get(ele, `${KP_P.Unternehmen.path}.id`) === eachPartnerId && get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme',
			);

			const ausgabenGesamtEachPartner = allAusgabenEachPartner_Arr.reduce((acc: any, ele: any) => {
				return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
			}, 0);
			const einnahmenGesamtEachPartner = allEinnahmenEachPartnerr_Arr.reduce((acc: any, ele: any) => {
				return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
			}, 0);
			const zuwendungGesamtEachPartner = ausgabenGesamtEachPartner - einnahmenGesamtEachPartner;
			const foerderQuoteEachPartner = ausgabenGesamtEachPartner !== 0 ? (zuwendungGesamtEachPartner / ausgabenGesamtEachPartner) * 100 : 0;

			result.push({
				path: `${P.Verbundpartner.path}.${i}.Foerderquote_Gesamt_403741`,
				value: !isNaN(foerderQuoteEachPartner) ? foerderQuoteEachPartner.toFixed(2) : 0,
			});
		}
	});

	// FörderQuote unabhängig von Antragsteller oder Parter
	// Gesamt aussicht
	const allAusgaben_Arr = allKostenPosition.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe');
	const allEinnahme_Arr = allKostenPosition.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme');

	const ausgabenGesamt = allAusgaben_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const einnahmennGesamt = allEinnahme_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const zuwendungGesamt = ausgabenGesamt - einnahmennGesamt;
	const foerderQuoteGesamt = ausgabenGesamt !== 0 ? (zuwendungGesamt / ausgabenGesamt) * 100 : 0;

	result.push({
		path: P.Bewilligung_Foerderquote_Gesamt.path,
		value: !isNaN(foerderQuoteGesamt) ? foerderQuoteGesamt.toFixed(2) : 0,
	});
	return result;
}

/*
 ***************************************************************************************************************
 * ************************ HELPER FUNCTIONS *******************************************************************
 * *************************************************************************************************************
 */
function calculateAllgemeinKostenProJehrGEsamtSumme(dataArray: any) {
	const total = dataArray.reduce((sum: any, item: any) => {
		// Convert the Zelle_2 value to a number and add it to the sum
		return sum + parseFloat(item.Zelle_2);
	}, 0);

	// Return the total formatted to 2 decimal places
	return total.toFixed(2);
}
const calculateFoerderquoteData = (data: any[]) => {
	// Extract all unique years from the data
	const years = Array.from(new Set(data.flatMap((item) => item.attributes.Allgemein_Kosten_Pro_Jahr.map((k: any) => k.Zelle_1))));

	// Calculate Foerderquote for each year
	const result = years.map((year) => {
		let sumAusgabe = 0;
		let sumEinnahme = 0;

		data.forEach((item) => {
			get(item, KP_P.Allgemein_Kosten_Pro_Jahr.path, []).forEach((kosten: any) => {
				if (kosten.Zelle_1 === year) {
					const value = parseFloat(kosten.Zelle_2);
					if (!isNaN(value)) {
						if (get(item, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe') {
							sumAusgabe += value;
						} else if (get(item, KP_P.Allgemein_Kostenposition.path) === 'Einnahme') {
							sumEinnahme += value;
						}
					}
				}
			});
		});

		const foerderquote = sumAusgabe !== 0 ? ((sumAusgabe - sumEinnahme) / sumAusgabe) * 100 : 0;

		return {
			Projektjahr: year,
			Foerderquote_403741: foerderquote.toFixed(2), // Round to two decimal places
		};
	});

	return result;
};

// Für Personal konsten
function transformData(eachPersonalKosten: any, isHochschule: boolean, ProjektJahrStart: any, projektDauer: number) {
	// Helper function to ensure the array length matches projektDauer, filling with empty objects if necessary
	const ensureArrayLength = (array: any[], length: number, filler: any) => {
		if (array.length > length) {
			return array.slice(0, length);
		} else {
			const newArray = array.map((item, index) => ({
				...item,
				Zelle_1: item.Zelle_1 !== undefined ? item.Zelle_1 : ProjektJahrStart + index,
			}));
			while (newArray.length < length) {
				newArray.push({
					...filler,
					Zelle_1: ProjektJahrStart + newArray.length,
				});
			}
			return newArray;
		}
	};

	// Helper function to calculate Zelle_2 for Allgemein_Kosten_Pro_Jahr
	const calculateAllgemeinKostenProJahr = (personalausgabenProjektjahrBlock1: any) => {
		return personalausgabenProjektjahrBlock1.map((item: any, i: number) => {
			const Zelle2Value = item.Zelle_3 ? parseFloat(item.Zelle_3) : '0.00';
			const result = {
				Zelle_1: item.Zelle_1,
				Zelle_2: Zelle2Value,
			};
			if (get(eachPersonalKosten, `${KP_P.Allgemein_Kosten_Pro_Jahr.path}.${i}.id`))
				set(result, 'id', get(eachPersonalKosten, `${KP_P.Allgemein_Kosten_Pro_Jahr.path}.${i}.id`));
			return result;
		});
	};

	// Helper function to calculate Personalausgaben details
	const calculatePersonalausgaben = (personalausgaben: any) => {
		const Projekt_Jahr_Block = get(
			personalausgaben,
			getFieldNamefromDataPath(KP_P.Personalausgaben_LOEWE_Antrag.schema.attributes.Loewe_Antrag_Projekt_Jahr.path),
			[],
		);

		const ProjektjahrBlock1 = Projekt_Jahr_Block.map((item: any, index: any) => {
			// Kalkulation Tabelle
			const PersonalausgabenProMonat = Number(item.Zelle_4) ? parseFloat(item.Zelle_4) : 0;
			const beschaeftigungMonate = Number(item.Zelle_5) ? parseFloat(item.Zelle_5) : 0;
			const StundenProWoche = Number(item.Zelle_6) ? parseFloat(item.Zelle_6) : 0;
			const GeplanteProjektstundenImJahr = Number(item.Zelle_2) ? parseFloat(item.Zelle_2) : 0;

			// Errechnete Tabelle
			const StundenProTag = StundenProWoche / 5;
			const PersonalausgabenImJahr = PersonalausgabenProMonat * beschaeftigungMonate;
			const maxEinsatzstage = beschaeftigungMonate * 17.5;
			const maxEinsatzstunden = maxEinsatzstage * StundenProTag;
			let Stundensatz = 0;

			if (isHochschule) {
				Stundensatz = Number(item.Zelle_11) ? parseFloat(item.Zelle_11) : 0;
			} else {
				Stundensatz = maxEinsatzstunden > 0 ? parseFloat((PersonalausgabenImJahr / maxEinsatzstunden).toFixed(2)) : 0;
			}

			// Gesamt Kosten im Jahr
			const ProjektbezogeneAusgaben = GeplanteProjektstundenImJahr && Stundensatz ? GeplanteProjektstundenImJahr * Stundensatz : 0;
			const result = {
				Zelle_1: ProjektJahrStart + index,
				// Kalkulation Tabelle
				Zelle_4: PersonalausgabenProMonat,
				Zelle_5: beschaeftigungMonate,
				Zelle_6: StundenProWoche,
				Zelle_2: GeplanteProjektstundenImJahr,
				// Errechnete Tabelle
				Zelle_8: StundenProTag,
				Zelle_7: PersonalausgabenImJahr.toFixed(2),
				Zelle_9: maxEinsatzstage.toFixed(2),
				Zelle_10: maxEinsatzstunden.toFixed(2),
				Zelle_11: !isNaN(Stundensatz) ? Stundensatz.toFixed(2) : 0,
				// Gesamt Kosten im Jahr
				Zelle_3: !isNaN(ProjektbezogeneAusgaben) ? ProjektbezogeneAusgaben.toFixed(2) : 0,
			};
			if (item.id) set(result, 'id', item.id);
			return result;
		});

		const ProjektjahrBlock2Zelle1 = ProjektjahrBlock1.reduce((sum: any, item: any) => sum + parseFloat(item.Zelle_2 || '0'), 0).toFixed(2);
		const ProjektjahrBlock2Zelle2 = ProjektjahrBlock1.reduce((sum: any, item: any) => {
			return sum + parseFloat(item.Zelle_3);
		}, 0).toFixed(2);

		return {
			...personalausgaben,
			[getFieldNamefromDataPath(
				KP_P.Personalausgaben_LOEWE_Antrag.schema.attributes.Personalausgaben_LOEWE_F_0206598338_Projektjahr_Block_2_Zelle_2.path,
			)]: ProjektjahrBlock2Zelle1,
			[getFieldNamefromDataPath(
				KP_P.Personalausgaben_LOEWE_Antrag.schema.attributes.Personalausgaben_LOEWE_F_0206598339_Projektjahr_Block_2_Zelle_3.path,
			)]: ProjektjahrBlock2Zelle2,
			// Komplete Kalkulation Tabelle Block
			[getFieldNamefromDataPath(KP_P.Personalausgaben_LOEWE_Antrag.schema.attributes.Loewe_Antrag_Projekt_Jahr.path)]: ensureArrayLength(
				ProjektjahrBlock1,
				projektDauer,
				{
					Zelle_2: null,
					Zelle_3: '0.00',
				},
			),
		};
	};
	// Calculate the transformed data
	const calculatedPersonalausgaben = calculatePersonalausgaben(get(eachPersonalKosten, KP_P.Personalausgaben_LOEWE_Antrag.path, {}));
	const calculatedAllgemeinKostenProJahr = calculateAllgemeinKostenProJahr(calculatedPersonalausgaben.Loewe_Antrag_Projekt_Jahr);

	return {
		...eachPersonalKosten,
		attributes: {
			...eachPersonalKosten.attributes,
			[getFieldNamefromDataPath(KP_P.Allgemein_Bezeichnung.path)]: get(calculatedPersonalausgaben, 'Name_Desder_Beschaeftigten', ''),
			// Allegmeine Kosten Pro Jahr Tabelle
			[getFieldNamefromDataPath(KP_P.Allgemein_Kosten_Pro_Jahr.path)]: ensureArrayLength(calculatedAllgemeinKostenProJahr, projektDauer, {
				Zelle_2: '0.00',
			}),
			// Gesamten Komponent für Personalausgaben
			[getFieldNamefromDataPath(KP_P.Personalausgaben_LOEWE_Antrag.path)]: calculatedPersonalausgaben,
			// Allgemeine gesamt Summe
			[getFieldNamefromDataPath(KP_P.Allgemein_Geplante_Gesamtsumme.path)]:
				calculateAllgemeinKostenProJehrGEsamtSumme(calculatedAllgemeinKostenProJahr),
		},
	};
}
// Pauschalen anlgen oder aktualisieren
function calculateAdministrationspauschale(application: any, kostenKategories: any) {
	let result: FormulasResultType[] = [];

	const orgaDaten = get(application, P.Antragstellende_Organisation.path, {});

	// Nur für HAW-Antragsteller
	if (!isAntragstellerHAW(orgaDaten)) {
		return result;
	}

	const unternehmenId = get(application, `${P.Antragstellende_Organisation.path}.id`);
	const allKostenPositionen = get(application, P.Foerderantrag_Kostenpositions.path, []);
	const projektDauer = get(application, P.Allgemein_Projektdauerin_Jahren.path, 0);
	const projektStartJahr = get(application, P.Allgemein_Projektstart_Jahr.path, 0);

	// 1. Alle Personalkosten des Antragstellers summieren (ohne Administrationspauschale)
	const personalKostenAntragsteller = allKostenPositionen.filter(
		(ele: any) =>
			get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe &&
			get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten &&
			get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId &&
			get(ele, KP_P.Allgemein_Kostentraeger.path) === KOSTENTRAEGER.Antragsteller &&
			!get(ele, KP_P.Personalausgaben_LOEWE_Antrag.schema.attributes.Administrationspauschale.path, false),
	);

	// 2. Pro Jahr die Summe der Personalkosten berechnen
	const summenProJahr: Record<number, number> = {};
	for (let j = 0; j < projektDauer; j++) {
		summenProJahr[projektStartJahr + j] = 0;
	}

	personalKostenAntragsteller.forEach((ele: any) => {
		const kostenProJahr = get(ele, KP_P.Allgemein_Kosten_Pro_Jahr.path, []);
		kostenProJahr.forEach((jahresKosten: any) => {
			const jahr = jahresKosten.Zelle_1;
			const betrag = parseFloat(jahresKosten.Zelle_2) || 0;
			if (summenProJahr[jahr] !== undefined) {
				summenProJahr[jahr] += betrag;
			}
		});
	});

	// 3. 20% pro Jahr berechnen
	const pauschaleProJahr = Object.entries(summenProJahr).map(([jahr, summe]) => ({
		Zelle_1: parseInt(jahr),
		Zelle_2: parseFloat((summe * 0.2).toFixed(2)),
	}));

	const gesamtSumme = pauschaleProJahr.reduce((acc, item) => acc + item.Zelle_2, 0).toFixed(2);

	// 4. Prüfen, ob bereits eine Administrationspauschale existiert
	const existingIndex = allKostenPositionen.findIndex(
		(ele: any) => get(ele, KP_P.Personalausgaben_LOEWE_Antrag.schema.attributes.Administrationspauschale.path, false) === true,
	);

	if (existingIndex >= 0) {
		// Aktualisieren
		result.push({
			path: addIndexesToPath(
				P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr.path,
				[`${existingIndex}`],
				['Foerderantrag_Kostenpositions'],
			),
			value: pauschaleProJahr,
		});
		result.push({
			path: addIndexesToPath(
				P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
				[`${existingIndex}`],
				['Foerderantrag_Kostenpositions'],
			),
			value: gesamtSumme,
		});
		result.push({
			path: addIndexesToPath(
				P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_LOEWE_Antrag.path,
				[`${existingIndex}`],
				['Foerderantrag_Kostenpositions'],
			),
			value: {
				// Administrationspauschale ist die 20% Pauschale für HAW, die im Akkordion nicht angezeigt werden müssen.
				// Das nur  angelegt werden, wenn die Antragstellende ein HAW ist.
				Administrationspauschale: true,
				Name_Desder_Beschaeftigten: 'Administrationspauschale (anteilig max. 20% der Personalausgaben)',
			},
		});
	} else {
		// Neue Kostenposition anlegen
		// Kostenkategorie aus einer existierenden Personalkosten-Position des Antragstellers holen
		const existingPersonalKosten = allKostenPositionen.find(
			(ele: any) =>
				get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten &&
				get(ele, KP_P.Allgemein_Kostentraeger.path) === KOSTENTRAEGER.Antragsteller &&
				get(ele, `${KP_P.Unternehmen.path}.id`) === orgaDaten,
		);

		// Kostenkategorie-ID aus existierender Position oder aus kostenKategories nehmen
		const kostenKategorieId = existingPersonalKosten ? get(existingPersonalKosten, KP_P.Allgemein_Kostenkategorie.path) : null;

		const allKostenkategorieForPersonal = kostenKategories.filter(
			(ele: any) => get(ele, 'attributes.Allgemein_Kostenart_Finanzierung') === KOSTEN_ARTEN.Personalkosten,
		);

		const data = getBasisDataKostenKategorie(
			application,
			allKostenkategorieForPersonal,
			KOSTENTRAEGER.Antragsteller,
			unternehmenId,
			KOSTEN_POSITION.Ausgabe,
			KOSTEN_ARTEN.Personalkosten,
		);

		// Kostenkategorie überschreiben, falls aus existierender Position vorhanden
		if (kostenKategorieId) {
			set(
				data,
				getFieldNamefromDataPath(KP_P.Allgemein_Kostenkategorie.path),
				typeof kostenKategorieId === 'object' ? kostenKategorieId.id : kostenKategorieId,
			);
		}

		// Zusatzfelder setzen
		set(data, getFieldNamefromDataPath(KP_P.Allgemein_Bezeichnung.path), 'Administrationspauschale (anteilig max. 20% der Personalausgaben)');
		set(data, getFieldNamefromDataPath(KP_P.Personalausgaben_LOEWE_Antrag.path), {
			Administrationspauschale: true,
			Name_Desder_Beschaeftigten: 'Administrationspauschale (anteilig max. 20% der Personalausgaben)',
		});
		set(data, getFieldNamefromDataPath(KP_P.Allgemein_Kosten_Pro_Jahr.path), pauschaleProJahr);
		set(data, getFieldNamefromDataPath(KP_P.Allgemein_Geplante_Gesamtsumme.path), gesamtSumme);

		const newIndex = allKostenPositionen.length;
		result.push({
			path: addIndexesToPath(P.Foerderantrag_Kostenpositions.path, [`${newIndex}`], ['Foerderantrag_Kostenpositions']),
			value: { attributes: data },
		});
	}

	return result;
}

// Für Sachkosten
function transformSachkostenData(data: any, projektJahrStart: number, projektDauer: number) {
	const kostenProJahr = get(data, KP_P.Allgemein_Kosten_Pro_Jahr.path, []);

	// Ensure the array length matches projektDauer
	if (kostenProJahr.length < projektDauer) {
		// Add missing years with default values
		for (let i = kostenProJahr.length; i < projektDauer; i++) {
			kostenProJahr.push({
				Zelle_1: projektJahrStart + i,
				Zelle_2: null, // Default value
			});
		}
	} else if (kostenProJahr.length > projektDauer) {
		// Trim the array to match projektDauer
		kostenProJahr.splice(projektDauer);
	}

	// Update Zelle_1 and calculate Zelle_2 sum
	let sumZelle_2 = 0;
	kostenProJahr.forEach((item: any, index: number) => {
		item.Zelle_1 = projektJahrStart + index;
		sumZelle_2 += item.Zelle_2 ? parseFloat(item.Zelle_2) : 0; // Sum with 2 decimal places
	});

	// Update Allgemein_Geplante_Gesamtsumme
	data.attributes.Allgemein_Geplante_Gesamtsumme = sumZelle_2 ? sumZelle_2 : 0;

	// Ensure Zelle_2 values are 2 decimal numbers
	kostenProJahr.forEach((item: any) => {
		item.Zelle_2 = parseFloat(parseFloat(item.Zelle_2 || '0.0').toFixed(2));
	});

	return data;
}

function transformAllgemeinKostenProJahrData(data: any, projektJahrStart: number, ProjektJahrDauer: number) {
	// Filter and adjust the data length to match ProjektJahrDauer
	let adjustedData = data.slice(0, ProjektJahrDauer);

	// If the adjusted data length is less than ProjektJahrDauer, add missing years
	for (let i = adjustedData.length; i < ProjektJahrDauer; i++) {
		adjustedData.push({
			Zelle_1: projektJahrStart + i,
			Zelle_2: 0, // Default value if not provided
		});
	}

	// Adjust Zelle_1 to start from projektJahrStart and increment
	adjustedData = adjustedData.map((item: any, index: number) => ({
		...item,
		Zelle_1: projektJahrStart + index,
		Zelle_2: parseFloat(item.Zelle_2) || 0,
	}));

	// Calculate gesamtSumme
	const gesamtSumme = adjustedData.reduce((sum: any, item: any) => sum + item.Zelle_2, 0).toFixed(2);

	// Format adjusted data with 2 decimal places
	const KostenProJahr = adjustedData.map((item: any) => ({
		...item,
		Zelle_2: item.Zelle_2.toFixed(2),
	}));

	return {
		gesamtSumme: parseFloat(gesamtSumme).toFixed(2),
		KostenProJahr,
	};
}
function calculateFinancials(data: any) {
	const result: any = {};

	let gesamtAusgaben = 0;
	let gesamtEinnahme = 0;

	data.forEach((item: any) => {
		const { Allgemein_Kostenposition, Allgemein_Kosten_Pro_Jahr } = item.attributes;

		Allgemein_Kosten_Pro_Jahr.forEach((yearlyCost: any) => {
			const year = yearlyCost.Zelle_1;
			const amount = parseFloat(yearlyCost.Zelle_2) || 0;

			if (!result[year]) {
				result[year] = {
					Projektjahr: year,
					Ausgaben: 0,
					Eigen_45_Und_Drittmittel: 0,
				};
			}

			if (Allgemein_Kostenposition === 'Ausgabe') {
				result[year].Ausgaben += amount;
				gesamtAusgaben += amount;
			} else if (Allgemein_Kostenposition === 'Einnahme') {
				result[year].Eigen_45_Und_Drittmittel += amount;
				gesamtEinnahme += amount;
			}
		});
	});

	const Jahrenaufteilung = Object.values(result).map((item: any) => {
		const { Ausgaben, Eigen_45_Und_Drittmittel } = item;
		const Zuwendung = (Ausgaben || 0) - (Eigen_45_Und_Drittmittel || 0);
		const Foerderquote_403741 = Ausgaben > 0 ? (Zuwendung / Ausgaben) * 100 : 0;

		return {
			...item,
			Ausgaben: Ausgaben.toFixed(2),
			Eigen_45_Und_Drittmittel: Eigen_45_Und_Drittmittel.toFixed(2),
			Zuwendung: Zuwendung.toFixed(2),
			Foerderquote_403741: Foerderquote_403741.toFixed(2),
		};
	});

	const gesamtZuwendung = gesamtAusgaben - gesamtEinnahme;
	const gesamtFoerderQuote = gesamtAusgaben > 0 ? (gesamtZuwendung / gesamtAusgaben) * 100 : 0;

	return {
		gesamtAusgaben: !isNaN(gesamtAusgaben) ? gesamtAusgaben.toFixed(2) : 0,
		gesamtEinnahme: !isNaN(gesamtEinnahme) ? gesamtEinnahme.toFixed(2) : 0,
		gesamtZuwendung: !isNaN(gesamtZuwendung) ? gesamtZuwendung.toFixed(2) : 0,
		gesamtFoerderQuote: !isNaN(gesamtFoerderQuote) ? gesamtFoerderQuote.toFixed(2) : 0,
		Jahrenaufteilung,
	};
}

/**
 * ************************** ACHTUNG **************************
 * Diese Funktion wird auch an andere Stellen verwendet.
 * TODO:  Daher export nicht löschen. Es muss an richtige  Stelle (z.B. in irgendein uteil oder helper-Datei verschoben werden)
 */
export function isUnternehmenHochschule(eachKostenPosition: any, application: any): boolean {
	const kostenTraeger = get(eachKostenPosition, KP_P.Allgemein_Kostentraeger.path, '');

	if (kostenTraeger === KOSTENTRAEGER.Antragsteller) {
		const orgaAntragBerechtigt = get(application, P.Organisation_Antragsberechtigt_Als.path);

		return isAntragBerechtigtHochschule(orgaAntragBerechtigt);
	}

	if (kostenTraeger === KOSTENTRAEGER.Verbundpartner) {
		const vPartnerID = get(eachKostenPosition, `${KP_P.Unternehmen.path}.id`, '');
		const vPartner = get(application, P.Verbundpartner.path, []).find((ele: any) => get(ele, 'Verbundpartner.id') === vPartnerID);
		const vPartnerAntragBerechtigt = get(vPartner, ANTRAG_VERBUNDPARTNER.Antragberechtigt, {});
		return isAntragBerechtigtHochschule(vPartnerAntragBerechtigt);
	}
	return false;
}
